import React from 'react';
import styled from 'styled-components';

const CustomSelect = styled.select`
  padding: 12px;
  border-radius: 5px;
  border: 1px solid #ddd;
  margin: 10px;
  background-color: white;
  font-size: 14px;
  color: ${(props) => props.color || "#214160"};
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #01A8CE;
    box-shadow: 0 0 0 2px rgba(1, 168, 206, 0.2);
  }
`;

const SelectComponent: React.FC<{
  options: Array<{ value: string; label: string }>;
  value: string;
  onChange: (value: string) => void;
}> = ({ options, value, onChange }) => (
  <CustomSelect value={value} onChange={(e) => onChange(e.target.value)}>
    {options.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))}
  </CustomSelect>
);

export default SelectComponent;
